var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenulist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.3333C2.5 10.6095 2.72386 10.8333 3 10.8333H8.66667C8.94281 10.8333 9.16667 10.6095 9.16667 10.3333V3C9.16667 2.72386 8.94281 2.5 8.66667 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V10.3333ZM2.5 17C2.5 17.2761 2.72386 17.5 3 17.5H8.66667C8.94281 17.5 9.16667 17.2761 9.16667 17V13C9.16667 12.7239 8.94281 12.5 8.66667 12.5H3C2.72386 12.5 2.5 12.7239 2.5 13V17ZM10.8333 17C10.8333 17.2761 11.0572 17.5 11.3333 17.5H17C17.2761 17.5 17.5 17.2761 17.5 17V9.66667C17.5 9.39052 17.2761 9.16667 17 9.16667H11.3333C11.0572 9.16667 10.8333 9.39052 10.8333 9.66667V17ZM11.3333 2.5C11.0572 2.5 10.8333 2.72386 10.8333 3V7C10.8333 7.27614 11.0572 7.5 11.3333 7.5H17C17.2761 7.5 17.5 7.27614 17.5 7V3C17.5 2.72386 17.2761 2.5 17 2.5H11.3333Z",
    fill: "#8FA1A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenulist);
export default __webpack_public_path__ + "static/media/menulist.927873737dbeaa1bb910638f6443ce34.svg";
export { ForwardRef as ReactComponent };